import { clearPermissionDraft } from './permissionDraft';
import { invalidateRegistrationOwner } from './registrationDraft';
import { clearReviewDrafts } from './reviewDraft';
const LOCAL_CACHE_KEYS = {
    home: 'home_cache',
    medicationList: 'medlist_cache',
    settings: 'settings_cache',
};

const revisions = new Map();
let contextRevision = 0;
export function getScreenCacheContextRevision() { return contextRevision; }

export function getScreenCacheRevision(key) {
    return `${contextRevision}:${revisions.get(key) || 0}`;
}

function removeSessionKey(key) {
    revisions.set(key, (revisions.get(key) || 0) + 1);
    try {
        sessionStorage.removeItem(key);
    } catch {}
}

export function clearHomeCache() {
    removeSessionKey(LOCAL_CACHE_KEYS.home);
}

export function clearMedicationCaches() {
    removeSessionKey(LOCAL_CACHE_KEYS.home);
    removeSessionKey(LOCAL_CACHE_KEYS.medicationList);
}

function clearSettingsCache() {
    removeSessionKey(LOCAL_CACHE_KEYS.settings);
}

export function clearAllScreenCaches({ identityChanged = false } = {}) {
    contextRevision++;
    if (identityChanged) {
        clearReviewDrafts();
        clearPermissionDraft();
        invalidateRegistrationOwner();
        try { localStorage.removeItem('ai_chat_history'); } catch {}
    }
    clearMedicationCaches();
    clearSettingsCache();
    if (identityChanged && typeof window !== 'undefined') window.dispatchEvent(new Event('kkomok-account-context-changed'));
}
